module.exports = __webpack_public_path__ + "img/fankui_banner_es.7e257a73.jpg";